import script from "./PhoneticSymbolModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneticSymbolModal.vue?vue&type=script&setup=true&lang=js"

import "./PhoneticSymbolModal.vue?vue&type=style&index=0&id=6d9c3db8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d9c3db8"]])

export default __exports__